module.exports = __webpack_public_path__ + "img/e4b49c3.jpg";